import { getPluginConfiguration } from 'reducers/Plugins';
import { RootState } from 'reducers';
import { getAllMSEndpointsFromLS } from 'reducers/installer';

import { fiscalIntegrations } from '../integrations/FiscalIntegration';
import {
  Country,
  EFSTAConf,
  EFSTAConfCompany,
} from '../types/pluginTypes';
import { EFSTA_ID } from 'plugins/EFSTAFiscalIntegration/meta';

export function getEfstaConfiguration(state: RootState) {
  return getPluginConfiguration<EFSTAConf & EFSTAConfCompany>(EFSTA_ID)(state);
}

export function getSelectedCountry(state: RootState) {
  const configuration = getEfstaConfiguration(state);
  return configuration.country;
}

export function getFiscalIntegrationForCountry(country: Country) {
  if (country in fiscalIntegrations) {
    return fiscalIntegrations[country];
  }
  return fiscalIntegrations.NULL;
}

export function getFiscalIntegrationForSelectedCountry(state: RootState) {
  const country = getSelectedCountry(state);
  return getFiscalIntegrationForCountry(country);
}

// IMPORTANT: Not using createSelector on purpose to ensure LS changes are picked up
// DO NOT ADD createSelector/other memoization
export function getEFSTAEndpoint(state: RootState): string {
  return (
    (getEfstaConfiguration(state)?.endpoint ||
      getAllMSEndpointsFromLS()['efsta-fiscal-proxy']) ??
    `https://localhost.erply.com:10123/`
  );
}
